import React from 'react';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { combineClassNames } from '../../../../core/css';
import { Translate, useTranslate } from '../../../../core/translate';

const ViewControl = ({
  onToggle,
  limitColumns,
  columnLimit = 3,
  analyticsKey,
  hideFromTab = false,
  itemDescription,
}) => {
  const translate = useTranslate();
  return (
    <Tabs
      selectedIndex={limitColumns ? 0 : 1}
      onSelect={onToggle}
      selectedTabClassName="view-control-tabs__tab--active">
      <TabList className="view-control-tabs__tablist">
        <Tab
          tabIndex={hideFromTab ? '-1' : '0'}
          className={combineClassNames(
            'stat-button-link',
            'view-control-tabs__tab',
            'limited-views-tab'
          )}
          data-dtm={analyticsKey}
          aria-label={translate('compare.column.control.limit.aria.v3', {
            itemDescription,
          })}>
          <div
            className={combineClassNames(
              'view-control-tabs__label-outer',
              limitColumns ? 'view-control-tabs__label-outer--active' : ''
            )}>
            <span className="view-control-tabs__label">
              <Translate
                value="compare.view.control.columns.v3"
                numCols={columnLimit}
              />
            </span>
          </div>
        </Tab>
        <Tab
          key={1}
          tabIndex={hideFromTab ? '-1' : '0'}
          className={combineClassNames(
            'stat-button-link',
            'view-control-tabs__tab',
            'all-views-tab'
          )}
          data-dtm={analyticsKey}
          aria-label={translate('compare.column.control.all.aria.v3', {
            itemDescription,
          })}>
          <div
            className={combineClassNames(
              'view-control-tabs__label-outer',
              !limitColumns ? 'view-control-tabs__label-outer--active' : ''
            )}>
            <span className="view-control-tabs__label">
              <Translate value="compare.view.control.all.columns.v3" />
            </span>
          </div>
        </Tab>
      </TabList>
      <TabPanel />
      <TabPanel />
    </Tabs>
  );
};

export default ViewControl;
